import React from 'react'
import PropTypes from 'prop-types'
import CheckCircleOutlineIcon from 'Svgs/CheckCircle'

const FeaturePoint = ({ text }) => (
  <div className="my-2 mx-4">
    <CheckCircleOutlineIcon className="h-6 text-green-400 align-middle mr-4" />
    <span className="text-2xl text-gray-600">{text}</span>
  </div>
)

FeaturePoint.propTypes = {
  text: PropTypes.string.isRequired,
}

export default FeaturePoint
